module.exports = __webpack_public_path__ + "img/oncoming-bus.832e0706.png";